import { IPaymentDateChangeViewModel } from '../types/paymentDateChangeViewModel'

export class PaymentDateChangeViewModel implements IPaymentDateChangeViewModel
{
    nextPaymentDate: Date = undefined
	paymentDayOfWeek: string = ''
    paymentFrequencyTypeId: number = 0
    pageIndex: number = 0
	pageSize: number = 5
    totalRecords: number = 0
    validNewPaymentDates: Date[] = []
    leaseNumber: string = ''
    isActiveLease: boolean = false
    hasExistingPaymentDateChangeRequest: boolean = false
    existingPaymentDateChangeRequestId: string = ''
    referenceNumber: string = ''
}